module.exports = __webpack_public_path__ + "static/media/Img_17.3eaf8089.JPG";